/**
 * Bridge legacy helpers → source-aware official reading.
 * Prefer `resolveOfficialReading` / `nativeOfficialDrawPayload` for new code.
 */

import {
  resolveOfficialReading,
  type OfficialDrawNativeFields,
  type LotteryStyleSource,
} from './officialDrawFormat';

export type OfficialDrawPicksInput = OfficialDrawNativeFields & {
  source?: LotteryStyleSource | null;
};

export type OfficialDrawPicks = {
  pick3: string | null;
  pick4: string | null;
};

/** Resolve ### + #### for display (source-aware when `source` is set). */
export function enrichOfficialDrawPicks(input: OfficialDrawPicksInput): OfficialDrawPicks {
  const resolved = resolveOfficialReading(input.source ?? 'florida', input);
  return { pick3: resolved.pick3, pick4: resolved.pick4 };
}
